/**
 * 加载中动画组件
 *
 * 显示旋转的加载指示器
 */

import React from 'react';

interface LoadingSpinnerProps {
  /** 加载提示文本 */
  message?: string;
  /** 尺寸大小 */
  size?: 'sm' | 'md' | 'lg';
  /** 自定义类名 */
  className?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  message = '加载中...',
  size = 'md',
  className = '',
}) => {
  const sizeClasses = {
    sm: 'w-4 h-4 border-2',
    md: 'w-8 h-8 border-3',
    lg: 'w-12 h-12 border-4',
  };

  return (
    <div className={`flex flex-col items-center justify-center ${className}`}>
      <div
        className={`animate-spin rounded-full border-gray-200 border-t-gray-400 ${sizeClasses[size]}`}
        role="status"
        aria-label="加载中"
      >
        <span className="sr-only">加载中</span>
      </div>
      {message && (
        <p className="mt-3 text-sm text-gray-500">{message}</p>
      )}
    </div>
  );
};

export default LoadingSpinner;